// extracted by mini-css-extract-plugin
export default {"header":"Goals_header__PEhbc","text":"Goals_text__I6XWZ","wrapper":"Goals_wrapper__HbvIl","goals":"Goals_goals__kkodj"};